/**
 * Enlaces de soporte y comunidad de Robotea · fuente de verdad única.
 *
 * Distinción importante (no mezclar canales):
 * - Tutor IA (TutorSidebar): ayuda con los PASOS dentro del campus
 *   (curso, instalación del robot, VPS, MetaTrader). Es asistencia guiada
 *   automática, no soporte humano.
 * - Telegram: canal OFICIAL de SOPORTE TÉCNICO humano de Robotea. Para
 *   incidencias, dudas de configuración y atención del equipo.
 *
 * Centralizamos las URLs aquí para no hardcodearlas por toda la app y poder
 * cambiar el canal (p. ej. abrir la variante EN) en un solo sitio.
 */

/** Canal Telegram de soporte técnico de Robotea (ES + LATAM). */
export const TELEGRAM_SUPPORT_URL = 'https://t.me/robotea_es';

/** Canal Telegram de soporte técnico (EN · futuro · aún no en uso). */
export const TELEGRAM_SUPPORT_URL_EN = 'https://t.me/robotea_en';

// ───────────────────────────────────────────────────────────────────────────
// Atención al cliente COMERCIAL (precios · planes · upgrades) · 2026-06-17
//
// Jaime: las consultas comerciales/de precio del Tutor IA deben derivar a
// atención al cliente por WhatsApp (enlace directo), y los upsells ofrecer
// además "agendar llamada con un asesor" (calendario GHL).
//
// 🟡 FALLBACK TEMPORAL: aún NO tenemos esas URLs (pedidas a Escarly el
// 2026-06-17). Hasta que lleguen, ambos apuntan al canal de soporte (Telegram)
// para no dejar el CTA roto. SUSTITUIR EN CUANTO ESCARLY LAS PASE:
//   - WHATSAPP_SUPPORT_URL  → wa.me / api.whatsapp.com del WhatsApp de soporte.
//   - ASESOR_CALL_URL       → enlace del calendario de GHL para agendar llamada.
// ───────────────────────────────────────────────────────────────────────────

/** WhatsApp de atención al cliente (comercial / precios). TODO: URL real. */
export const WHATSAPP_SUPPORT_URL = TELEGRAM_SUPPORT_URL;

/** Calendario GHL para agendar llamada con un asesor (upsell). TODO: URL real. */
export const ASESOR_CALL_URL = TELEGRAM_SUPPORT_URL;
